import React, { Component } from 'react';
import SecuredRoute from './auth/SecuredRoute';
import OnBoarding from './pages/OnBoarding/OnBoarding';
import { Switch, Route, withRouter } from 'react-router-dom';
import AppContainer from './containers/AppContainer';
import Callback from './Callback/Callback';
import NavBar from './components/NavBar/NavBar';
import './styles.scss';
import NameEmail from './pages/NameEmail/NameEmail';
import ProfilePic from './pages/ProfilePic/ProfilePic';
import Services from './pages/Services/Services';
import InstagramProfile from './pages/InstagramProfile/InstagramProfile';
import HalfComplete from './pages/HalfComplete/HalfComplete';
import Location from './pages/Location/Location';
import HomeStudio from './pages/HomeStudio/HomeStudio';
import MobileService from './pages/MobileService/MobileService';
import ProgressChecklist from './pages/ProgressChecklist/ProgressChecklist';
import MakeupBrands from './pages/MakeupBrands/MakeupBrands';
// import VerifyInstagram from './pages/VerifyInstagram/VerifyInstagram';
import SelfieVerification from './pages/SelfieVerification/SelfieVerification';
import HowDidYouFind from './pages//HowDidYouFind/HowDidYouFind';
import ServiceType from './pages/ServiceType/ServiceType';
import Finish from './pages/Finish/Finish';
import Agreement from './pages/Agreement/Agreement';

class Routes extends Component<any> {
  render() {
    return (
      <div className="container is-fluid">
        <NavBar />
        <div className="form-background">
          <Switch>
            <SecuredRoute exact path="/" component={OnBoarding} />
            <SecuredRoute exact path="/step-1" component={NameEmail} />
            <SecuredRoute exact path="/step-2" component={ProfilePic} />
            <SecuredRoute exact path="/step-3" component={SelfieVerification} />

            <SecuredRoute exact path="/step-4" component={Services} />
            <SecuredRoute exact path="/step-5" component={ServiceType} />

            {/* <SecuredRoute exact path="/step-5" component={HalfComplete} /> */}
            <SecuredRoute exact path="/step-6" component={HomeStudio} />
            <SecuredRoute exact path="/step-7" component={MobileService} />
            {/*  <SecuredRoute exact path="/step-7" component={ProgressChecklist} /> */}
            <SecuredRoute exact path="/step-8" component={MakeupBrands} />
            {/*  <Route exact path="/step-11" component={VerifyInstagram} /> */}
            <SecuredRoute exact path="/step-9" component={InstagramProfile} />
            <SecuredRoute exact path="/step-10" component={HowDidYouFind} />
            <SecuredRoute exact path="/step-11" component={Agreement} />
            <SecuredRoute exact path="/step-12" component={Finish} />
            <Route path="/callback" render={props => <Callback {...props} />} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default withRouter(Routes);
